import { createFileRoute, redirect } from '@tanstack/react-router'

import { ACCOUNT_PATHS } from '@/features/user/profile'

/**
 * Rota legada. Cai no perfil, e não direto no editor: quem chega por um link
 * antigo passa a ver o contexto da conta, com o editor a um toque de distância.
 */
export const Route = createFileRoute('/_event/meu-avatar')({
  beforeLoad: () => {
    throw redirect({
      to: ACCOUNT_PATHS.profile,
      replace: true
    })
  }
})
